import { useEntitySelection } from '@shared/api/providers/entitySelection';
import { ButtonView } from '@shared/components/View';
import type { Entity } from '@shared/data/entity';
import styles from './EntitySelectionOverlay.module.css';

interface Props {
  entity: Entity;
}

export function EntitySelectionOverlay({ entity }: Props) {
  const { toggleEntity } = useEntitySelection();

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    toggleEntity(entity);
  };

  return <ButtonView onClick={onClick} className={styles.entitySelectionOverlay} />;
}
